
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// Servicios 
import { LugaresService} from '../services/lugares.service';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html'  
})
export class DetalleComponent {
    // inicializadores 
    idLugar:number=null;
    lugar:any = null;
    //----------------
    /*
    lugares:any=[
        {id:1,nombre:'negocio 1', active: true, cercania:1, distancia: 1.2, plan:'pagado', descripcion:'desc lugar #1 algo tedioso'},
        {id:2,nombre:'negocio 2', active: false, cercania:3, distancia: 1.5, plan:'gratis', descripcion:'desc descripcion lugar #2'},
        {id:3,nombre:'negocio 3', active: true, cercania:1, distancia: 5, plan:'pagado', descripcion:'descripcion #3, lugar maluco para llegar'},
        {id:4,nombre:'negocio 4', active: false,cercania:2, distancia:7, plan:'gratis', descripcion:'descripcion#4, muy fluido y facil de llegar, señalizado'}
    ];
    */    
    //
    constructor(private route: ActivatedRoute, private lugaresService:LugaresService){
        // imprime el parametro
        console.log(this.route.snapshot.params['id']);
        console.log(this.route.snapshot.queryParams['refered']);
        console.log(this.route.snapshot.queryParams['actionMain']);
        this.idLugar=this.route.snapshot.params['id'];

        //console.log(this.buscarLugarById());

        this.lugar=this.lugaresService.buscarLugar(this.idLugar);
    }

    // Buscar algun lugar
    /*
    buscarLugarById(){
        return this.lugares.filter((lugar)=> {
            return lugar.id == this.idLugar})[0] || null;
    }
    */
}




// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/detalle/detalle.component.ts